// Module
var code = "<template> <require from=\"app/core/components/resources/resources-view\"></require> <resources-view></resources-view> </template> ";
// Exports
module.exports = code;